import { FC } from 'react';
import ImageCard from './slots/ImageCard';
import HeaderCard from './slots/HeaderCard';
import KnowMoreCard from './slots/KnowMore';
import BodyCard from './slots/BodyCard';
interface CardInterface {
  title: string;
  subtitle?: string;
  color: string;
  imageUrl: string;
  body: string;
  link: string;
  onClick?: () => void;
}

const Card: FC<CardInterface> = (props: CardInterface) => {
  return (
    <div className="flex items-center justify-center">
      <div className="w-[348px] h-[448px] overflow-hidden bg-neutral-light/30 rounded-lg transition-all duration-500 hover:scale-[1.03]">
        <div>
          <ImageCard src={props.imageUrl} colorBackground={props.color} />
        </div>
        <div className="font-semibold text-base leading-6 text-neutral-darkest px-8 mt-0">
          <HeaderCard title={props.title} subtitle={props.subtitle} />
        </div>
        <div className="flex flex-wrap items-start h-[4.313rem] text-sm leading-6 font-normal py-2 pl-8">
          <BodyCard body={props.body} />
        </div>
        <div>
          <KnowMoreCard link={props.link} text="Saiba mais" onClick={props.onClick} />
        </div>
      </div>
    </div>
  );
};

export default Card;
